<script lang="ts" setup>
import { ref, reactive, watch, nextTick } from 'vue';
import { Vector3 } from '@babylonjs/core/Maths/math.vector';

interface IProps {
  coordinate: Vector3;
  editable: boolean;
}

interface IEmits {
  (e: 'change', value: Vector3): unknown;
}

const props = defineProps<IProps>();
const emit = defineEmits<IEmits>();
const coordinate = reactive(new Vector3(
  Number.parseFloat(props.coordinate.x.toFixed(6)),
  Number.parseFloat(props.coordinate.y.toFixed(6)),
  Number.parseFloat(props.coordinate.z.toFixed(6)),
));
const propUpdate = ref(true);

const propsCoordinateWatcher = (newCoordinate: Vector3) => {
  propUpdate.value = true;

  coordinate.set(
    Number.parseFloat(newCoordinate.x.toFixed(6)),
    Number.parseFloat(newCoordinate.y.toFixed(6)),
    Number.parseFloat(newCoordinate.z.toFixed(6)),
  );

  nextTick(() => {
    propUpdate.value = false;
  });
};

const coordinateWatcher = () => {
  if (propUpdate.value === true) return;

  emit('change', coordinate);
};

watch(() => props.coordinate, propsCoordinateWatcher, { deep: true });
watch(coordinate, coordinateWatcher, { deep: true });
</script>

<template>
  <div class="pl-2 font-mono text-sm leading-none flex flex-col">
    <template v-if="props.editable === true">
      <div class="w-full flex flex-row">
        <span>x:&nbsp;</span>
        <input
          v-model="coordinate.x"
          class="flex-grow border"
          type="number"
          step="0.000001"
        >
      </div>
      <div class="w-full flex flex-row">
        <span>y:&nbsp;</span>
        <input
          v-model="coordinate.y"
          class="flex-grow border"
          type="number"
          step="0.000001"
        >
      </div>
      <div class="w-full flex flex-row">
        <span>z:&nbsp;</span>
        <input
          v-model="coordinate.z"
          class="flex-grow border"
          type="number"
          step="0.000001"
        >
      </div>
    </template>
    <template v-if="props.editable !== true">
      <span>x:&nbsp;<span>{{ props.coordinate.x.toFixed(6) }}</span></span>
      <span>y:&nbsp;<span>{{ props.coordinate.y.toFixed(6) }}</span></span>
      <span>z:&nbsp;<span>{{ props.coordinate.z.toFixed(6) }}</span></span>
    </template>
  </div>
</template>
